
import {DigitizationTools} from "../ToolRegistry.js";
import {polygonArea, polygonPerimeter} from "../geometry/measurementGeometry.js";
import {formatLength} from "./distanceTool.js";

import {t, T} from "../i18n/index.js";
// Shared with basicGeometryTools.js's Polygon tool, which wants the same
// green fill/area-label look for its own (unlabelled-segment) polygon.
export const FILL_COLOR = 0x2ecc71;
export const FILL_OPACITY = 0.35;

// Same "mindst millimeter" precision as formatLength() - a 3-decimal
// square-meter value still resolves to sub-mm precision on typical
// digitization-scale features.
export function formatArea(squareMeters){
	return `${squareMeters.toFixed(3)} m²`;
}

export function averagePosition(raw){
	const sum = raw.reduce((acc, p) => [acc[0] + p[0], acc[1] + p[1], acc[2] + p[2]], [0, 0, 0]);
	return {x: sum[0] / raw.length, y: sum[1] / raw.length, z: sum[2] / raw.length};
}

// Mål areal: same interaction as the existing Polygon tool (left-click adds
// a point, right-click closes/finishes, minimum 3 points - enforced by
// FeatureVisual's own minVertices for geometryType "Polygon"), with the
// same Målinger label contract as Mål afstand (task's own established
// pattern, applied consistently here even though the task's own spec only
// detailed afstand/højde explicitly): no vertex coordinate labels, a
// length label on every edge (including the closing edge - FeatureVisual
// already treats a Polygon as `closed`, so segmentLabelFormat covers all
// of them for free), one summary label with name/area/perimeter/point
// count, anchored at the polygon's own centroid rather than a vertex
// (reads more naturally sitting inside the shape than off to one corner).
export const AreaTool = {
	id: "digitize_area",
	name: T("Mål areal"),
	category: "measurement",
	kind: "measurement",
	toolbarGroup: "measurement",
	toolbarOrder: 30,
	icon: "measure_area.svg",
	resultGeometryType: "Polygon",
	maxPoints: Infinity,
	tooltip: T("Mål arealet og omkredsen af et digitaliseret område i punktskyen."),
	instructions: T("Venstreklik for at placere områdets punkter. Højreklik for at afslutte og lukke området."),

	suppressVertexLabels: true,
	segmentLabelFormat: (a, b) => formatLength(a.distanceTo(b)),

	// User-requested semi-transparent green fill.
	fillColor: FILL_COLOR,
	fillOpacity: FILL_OPACITY,

	summaryLabelFormat(raw, visual){
		if(raw.length < 3) return null;
		return [
			visual.name,
			t("Areal: {0}", formatArea(polygonArea(raw))),
			t("Omkreds: {0}", formatLength(polygonPerimeter(raw))),
			t("Antal punkter: {0}", raw.length),
		];
	},
	summaryLabelAnchor(raw){
		return averagePosition(raw);
	},
};

DigitizationTools.register(AreaTool);
